"use client";

import moment from "moment";
import Image from "next/image";
import React from "react";
import styles from "@/components/Offers/SingleOfferCard/SingleOfferCard.module.scss";
import OfferConfirmationModal from "@/components/OfferConfirmationModal";

type SingleOfferCardProps = {
  data: any;
};

const SingleOfferCard = ({ data }: SingleOfferCardProps) => {
  const [showModal, setShowModal] = React.useState(false);
  const jet = data?.attributes;

  function closeModal() {
    setShowModal(false);
  }

  return (
    <>
      <article className={styles.card}>
        <div className={styles.flight}>
          <div className={styles.flight__image}>
            <Image
              src="/assets/images/offers_gen_img.png"
              alt="Private Jet Image"
              fill
            />
          </div>
          <h3 className={styles.flight__name}>{jet?.jet_name}</h3>
          <p className={styles.flight__type}>{jet?.jet_type}</p>
        </div>
        <div className={styles.details}>
          <p className={styles.details__offer_duration}>
            Offer Duration: {jet?.offer_duration}
          </p>
          <div className={styles.details__route}>
            <div className={`${styles.airport} ${styles.source}`}>
              <p className={styles.code}>{jet?.from_airport_code}</p>
              <p className={styles.name}>{jet?.from_airport_name}</p>
            </div>
            <div className={styles.flight_duration}>
              <p className={styles.date_time}>
                {moment(jet?.flight_date).format("DD MMM YYYY")}
              </p>
              <div className={styles.box}>
                <div className="border-b border-b-[#5a558e] absolute top-1/2 -translate-y-1/2 w-full"></div>
                <div className="img absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2">
                  <div className="relative w-6 h-6">
                    <Image
                      src="/assets/icons/aeroplane.svg"
                      alt="airplane icon"
                      fill
                      className="object-cover left-1/2"
                    />
                  </div>
                </div>
              </div>
              <p className={styles.date_time}>{jet?.flight_duration}</p>
            </div>
            <div className={`${styles.airport} ${styles.destination}`}>
              <p className={styles.code}>{jet?.to_airport_code}</p>
              <p className={styles.name}>{jet?.to_airport_name}</p>
            </div>
          </div>
        </div>
        <div className={styles.more_info}>
          <div className={styles.price_head}>
            <p className={styles.heading}>Price (excluding tax)</p>
            <p className={styles.price}>{jet?.price_in_usd_without_tax} USD</p>
          </div>
          <button
            className={styles.button}
            onClick={() => setShowModal(true)}
            aria-label="more info button"
          >
            More Info
            <span className="relative w-5 h-5">
              <Image
                src="/assets/icons/right-arrow.svg"
                alt="arrow icon"
                fill
              />
            </span>
          </button>
        </div>
      </article>
      {showModal && (
        <OfferConfirmationModal
          isOpen={showModal}
          onClose={closeModal}
          data={jet}
        />
      )}
    </>
  );
};

export default SingleOfferCard;
